import { BowelMovementScreen } from "app/screens/residents/show/BowelMovementScreen";

export default function BowelMovementPage() {
  return <BowelMovementScreen />;
}
